import type { NavEntry } from './types';
import type { ScreenId } from '@/app/navigation/types';

// Общая основа кабинета: то, что одинаково у всех брендов. Конкретный бренд
// объявляется как «база минус/плюс дельта» — так расхождение видно списком,
// а не диффом двух почти одинаковых файлов.

// Все экраны реестра. Спрятать экран у бренда = убрать его из этого списка в
// конкретном конфиге (раньше для этого комментировали роут и пункт меню).
export const BASE_SCREENS: ScreenId[] = [
  'stat.general',
  'stat.trafficback',
  'subscriptions',
  'transactions',
  'streams',
  'streams.new',
  'streams.edit',
  'iprates',
  'sources',
  'landings',
  'tds',
  'payments',
  'referals',
  'news',
  'faq',
  'rules',
  'support',
  'support.ticket',
  'settings',
  'settings.2fa',
];

// Порядок и состав 1:1 с прежним MENU_ITEMS из MenuList.tsx. Подписи не
// перечисляются: по умолчанию пункт берёт заголовок своего экрана из реестра
// (screens.ts → titleKey), labelKey нужен только там, где подпись в меню
// отличается от заголовка экрана («Основная» против «Статистика»).
export const BASE_NAV: NavEntry[] = [
  {
    kind: 'group',
    labelKey: 'stat',
    icon: 'Chart_Bar',
    primary: 'stat.general',
    items: [
      { screen: 'stat.general', labelKey: 'statMain' },
      { screen: 'subscriptions' },
      { screen: 'transactions' },
      { screen: 'stat.trafficback' },
    ],
  },
  { kind: 'link', screen: 'sources', icon: 'Cloud_Download' },
  {
    kind: 'group',
    // Подписи, зависящие от терминологии бренда, приходят из словаря:
    // у WapClick nav.streams = «Потоки», nav.streamsList = «Мои потоки»
    // (ТЗ п.8, src/brand/wapclick/locales).
    labelKey: 'streams',
    icon: 'Arrow_Left_Right',
    primary: 'streams',
    items: [{ screen: 'streams', labelKey: 'streamsList' }, { screen: 'iprates' }],
  },
  { kind: 'link', screen: 'landings', icon: 'Landing' },
  { kind: 'link', screen: 'payments', icon: 'Money' },
  { kind: 'link', screen: 'referals', icon: 'Users', requires: 'referralSystem' },
  { kind: 'link', screen: 'tds', icon: 'Car_Auto' },
  { kind: 'link', screen: 'news', icon: 'File_Document', badge: 'news' },
  { kind: 'link', screen: 'settings', icon: 'Settings' },
  { kind: 'link', screen: 'support', icon: 'Chat_Conversation', badge: 'tickets' },
  // Help_Book, а не Circle_Help: последний занят статусными «вопросиками»
  // в Выплатах и Источниках, и подменять его брендовой иконкой меню нельзя.
  { kind: 'link', screen: 'faq', icon: 'Help_Book' },
  // Book_Open — кастомная иконка (Files/Landing в паке идентичны, из-за чего
  // Правила визуально дублировались с Лендингами).
  { kind: 'link', screen: 'rules', icon: 'Book_Open' },
];
